module.exports = __webpack_public_path__ + "static/media/platform_6.8d7f13f9.svg";